import React, { FC, HTMLAttributes, ReactNode } from "react";
import { ElProcess, ElProcessContent, ElColumn, elGapProcess, elBgWhite, ElDotCircle, ElCrossLine } from "./process.css";
import { Container } from "../../layout";
import { ElHeadLine } from "../head-title";
interface IProcessProps extends HTMLAttributes<HTMLElement> {
  data: {
    icon: ReactNode;
    text: string;
  }[];
}

export const Process: FC<IProcessProps> = ({ children, data, ...props }) => {
  return (
    <ElProcess {...props}>
      <Container className={elGapProcess}>
        <ElProcessContent>
          <ElHeadLine style={{ "--hashTag": `"#EXPLORE PROGRAM"` }}>Proses Kurasi</ElHeadLine>
        </ElProcessContent>
        <ElProcessContent>
          {data.map((dataItem, key) => (
            <ElColumn className={elBgWhite} key={key}>
              <ElCrossLine />
              <ElDotCircle>{key + 1}</ElDotCircle>
              {dataItem.icon}
              <p>{dataItem.text}</p>
            </ElColumn>
          ))}
        </ElProcessContent>
      </Container>
    </ElProcess>
  );
};
